import {
  GESUNDHEITS_PROGRAMM_BALANCE_ID,
  GESUNDHEITS_PROGRAMM_BODY_ID,
  GESUNDHEITS_PROGRAMM_CARDIO_FIT_ID,
  GESUNDHEITS_PROGRAMM_DETOX_ID,
  GESUNDHEITS_PROGRAMM_RUECKEN_FIT_ID,
  IAttributGruppe,
  IDienstleistung,
  isAyurvedaPrgoramm,
  isKidsPrgoramm
} from '@mng/mgs-lib';

export interface IAnzeigeAttributGruppenInfo {
  simple: boolean;
  simpleType?: 'tab' | '';
  attributGruppen: IAttributGruppe[];
}

const programmeFuer1Child = [
  GESUNDHEITS_PROGRAMM_BODY_ID,
  GESUNDHEITS_PROGRAMM_CARDIO_FIT_ID,
  GESUNDHEITS_PROGRAMM_BALANCE_ID,
  GESUNDHEITS_PROGRAMM_DETOX_ID,
  GESUNDHEITS_PROGRAMM_RUECKEN_FIT_ID
];

export function attributGruppenInfoFuerAnzeige(dienstleistung: IDienstleistung): IAnzeigeAttributGruppenInfo {
  if (dienstleistung) {
    const attributGruppen = dienstleistung.attributGruppen;

    if (isKidsPrgoramm(dienstleistung.programm.id)) {
      return { simple: true, simpleType: 'tab', attributGruppen: attributGruppen[0].childAttributGruppen };
    }

    if (isAyurvedaPrgoramm(dienstleistung.programm.id)) {
      return attributGruppenFuerAyurveda(attributGruppen);
    }

    if (programmeFuer1Child.includes(dienstleistung.programm.id)) {
      return createAttributGruppeMit1Child(attributGruppen);
    }

    if (attributGruppen.length > 1) {
      return { attributGruppen, simple: false };
    } else if (attributGruppen.length === 1) {
      if (!attributGruppen[0].definitionen?.length && attributGruppen[0].childAttributGruppen?.length > 0) {
        if (attributGruppen[0].childAttributGruppen[0].definitionen?.length) {
          return { attributGruppen: attributGruppen[0].childAttributGruppen, simple: true };
        } else if (attributGruppen[0].childAttributGruppen[0].childAttributGruppen?.length > 0) {
          return { attributGruppen: attributGruppen[0].childAttributGruppen[0].childAttributGruppen, simple: true };
        }
      }

      return { attributGruppen, simple: true };
    }

    console.log('Es gibt keine Attribut Gruppen!!');
  }

  return { simple: true, attributGruppen: [] };
}

function attributGruppenFuerAyurveda(attributGruppen: IAttributGruppe[]): IAnzeigeAttributGruppenInfo {
  const resultAttributGruppen = [...attributGruppen];
  const einzelLeistungenGruppe = attributGruppeMit1Child('Einzelleistungen', collectDefinitionen(attributGruppen[0]));
  resultAttributGruppen[0] = einzelLeistungenGruppe;
  return { simple: false, attributGruppen: resultAttributGruppen };
}

/**
 * Die Attribut Gruppen eines Programms werden "zusammengefasst" in 1
 *
 */
function createAttributGruppeMit1Child(attributGruppen: IAttributGruppe[]): IAnzeigeAttributGruppenInfo {
  const result = {
    simple: true,
    attributGruppen: [{ label: attributGruppen[0].label, definitionen: collectDefinitionen(attributGruppen[0]) }]
  };
  return result;
}

function attributGruppeMit1Child(label: string, definitionen: number[]): IAttributGruppe {
  return {
    label,
    definitionen: [],
    childAttributGruppen: [{ label, definitionen }]
  } as IAttributGruppe;
}

function collectDefinitionen(attributGruppe: IAttributGruppe, definitionen: number[] = []) {
  if (attributGruppe.definitionen?.length > 0) {
    definitionen.push(...attributGruppe.definitionen);
  }

  if (attributGruppe.childAttributGruppen?.length > 0) {
    attributGruppe.childAttributGruppen.forEach((childAttributGruppe) =>
      collectDefinitionen(childAttributGruppe, definitionen)
    );
  }
  return definitionen;
}
